import React, { useState } from "react";
import "../App.css";
import { useLocation, useNavigate } from "react-router-dom";
import pc2 from '../images/pc2.png';


const App = () => {
  const [text, setText] = useState("");
  const [isCorrect, setIsCorrect] = useState(false);
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [showImage, setShowImage] = useState(false);

  const handleShowImage = () => {
    setShowImage(true);
  };

  const handleCloseImage = () => {
    setShowImage(false);
  };

  const navigate = useNavigate();
  const location = useLocation();
  const answer = location.state.answer;
  const allResults = location.state.allResults;
  const round = location.state.round;
  const binaryInputValue = location.state.binaryInputValue;
  const inputValue = location.state.inputValue;
  const randomNum = location.state.randomNum;

  let roundCount = 3

  const handleChange = (e) => {
    setText(e.target.value);
  };

  const verifyText = () => {
    let answerString = answer.join("");
    answerString = answerString.slice(0, 12);
    //console.log("ans",answerString)
    if (text === answerString) {
      setIsCorrect(true);
    } else {
      setIsCorrect(false);
      //console.log(answer);
    }
  };

  const showSnackbar = () => {
    let answerString = answer.join("");
    answerString = answerString.slice(0, 12);
    if (text === answerString) {
      setSnackbarVisible({ visible: true, color: 'green', });
    } else {
      setSnackbarVisible({ visible: true, color: 'red' });
    }
    setTimeout(() => {
      setSnackbarVisible({ visible: false });
    }, 3000);
  };

  const firstpage = () => {
    //console.log("firstpage");
  };
  //console.log("randomNum: ",randomNum)
  const secondpage = () => {
    if (isCorrect) {
      if (round-1 === 2){
        navigate("/page5", { state: { allResults, binaryInputValue, inputValue , randomNum , roundCount} });
      }
      else{
        roundCount = randomNum
        
        navigate("/page5", { state: { allResults, binaryInputValue, inputValue , randomNum , roundCount} });
      }
    } 
    else {
      alert("To proceed you have to get the Answer right");
    }
  };

  return (
    <>
      <div className="app-wrapper">
       
        <div className="text-xl text-center py-5">Round {round} Key Generation</div>

        <div className="input-container">
          <div className="flex items-center space-x-4">
            <div className="flex flex-col space-y-4">
              <p>Left 28 bits after shift</p>
              <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
                {allResults[round-1][1][0][0]}
                <br />
                {allResults[round-1][1][0][1]}
                <br />
                {allResults[round-1][1][0][2]}
                <br />
                {allResults[round-1][1][0][3]}
              </div>
              <p>Right 28 bits after shift</p>
              <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
                {allResults[round-1][1][1][0]}
                <br />
                {allResults[round-1][1][1][1]}
                <br />
                {allResults[round-1][1][1][2]}
                <br />
                {allResults[round-1][1][1][3]}
              </div>
            </div>

            <svg
              width="100"
              height="38"
              viewBox="0 0 573 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                fill="black"
              />
            </svg>

            <div className="flex flex-col space-y-4">
          <p>56 Bits</p>
          <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
          {allResults[round-1][1][0][0]} <br></br>{allResults[round-1][1][0][1]}
            <br></br>
            {allResults[round-1][1][0][2]}<br></br> {allResults[round-1][1][0][3]}
            <br></br>
            {allResults[round-1][1][1][0]} <br></br>{allResults[round-1][1][1][1]}
            <br></br>
            {allResults[round-1][1][1][2]} <br></br>{allResults[round-1][1][1][3]}
            <br></br>
          </div>
        </div>

            <svg
              width="100"
              height="38"
              viewBox="0 0 573 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                fill="black"
              />
            </svg>

            <div className="flex flex-col space-y-4">
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <p>Calculate the first 12 bits of Effective 48 Bit Key</p>
              <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
                {text.slice(0, 12)}
                <br />
                {allResults[round-1][2].slice(12, 24)}
            <br></br>
            {allResults[round-1][2].slice(24, 36)}
            <br></br>
            {allResults[round-1][2].slice(36, 48)}
            <br></br>
              </div>
              <br></br>
              <br></br>
              <button onClick={() => { verifyText(); showSnackbar();}} className="next-button">
                Verify
              </button>

              {snackbarVisible.visible && (
        <div
          id="snackbar"
          className={`show ${snackbarVisible.color === 'green' ? 'green' : 'red'}`}
        >
          {snackbarVisible.color === 'green'
            ? 'Correct Answer!'
            : 'Incorrect Answer! Please try again'}
        </div>
      )}

              <div className="input-box">
                <input
                  type="text"
                  onChange={handleChange}
                  placeholder="Type here..."
                  maxLength="12"
                />
              </div>
              <div className="p-8">
      {/* Button to show image */}
      <button onClick={handleShowImage} className="bg-blue-500 text-white p-2 rounded text-xs">
        Show permutation table
      </button>

      {/* Image container with close button */}
      {showImage && (
        <div className="fixed top-0 right-0 p-4 bg-white shadow-md">
          <button onClick={handleCloseImage} className="text-gray-500 hover:text-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-6 w-6">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
          <img src={pc2} alt="Displayed Image" className="mt-4" />
        </div>
      )}
    </div>
            </div>
          </div>
        </div>

        

        <div className="button-holder">
          <div className="prev-button" onClick={firstpage}>
            PREVIOUS
          </div>
          <div className="circle-container">
            {[...Array(16)].map((_, index) => (
              <div
                key={index}
                className={`circle ${index === round-1 ? "green" : "orange"}`}
              >
                {index + 1}
              </div>
            ))}
          </div>
          <div
            className={`next-button ${!isCorrect ? "disabled-button" : ""}`}
            onClick={secondpage}
          >
            NEXT
          </div>
        </div>
      </div>
    </>
  );
};

export default App;
